import React, { useState, useEffect, useContext } from "react";
import { Typography, Button, Space, Divider, message } from "antd";
import { ShoppingCartOutlined, PlusOutlined, PhoneOutlined } from "@ant-design/icons";
import LineButton from '../../components/line-button';
import UpFinger from '../../assets/images/png/up-sign.png';
import ProductCard from '../../components/product-card';
import ApiServeice from '../../utils/apiServices'
import './style.css'
import BackButton from "../../components/back-button";
import { pin_products } from '../../utils/schemas';

// Import images
import SampleImg1 from '../../assets/images/png/bag-fashion-1.jpg';
import SampleImg2 from '../../assets/images/png/bag-fashion-2.jpg';
import SampleImg3 from '../../assets/images/png/bag-fashion-3.jpg';
import SampleImg4 from '../../assets/images/png/bag-fashion-4.jpg';
import { products } from "../../utils/schemas";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../components/loading";
import { MainStore } from "../../utils/store/context";




const pageContainerStyle = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px 0",
};

const productInfoStyle = {
    paddingTop: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
};

const titleStyle = {
    fontSize: 'clamp(16px, 2vw, 25px)',
    fontWeight: "bold",
    color: "#333",
    marginTop: "10px"
};

const productCodeStyle = {
    fontSize: "clamp(14px, 2vw, 20px)",
    color: "#999",
    display: "block",
    marginTop: "0px",
    marginBottom: 5
};


const cartButtonStyle = {
    backgroundColor: "#fd0088",
    borderColor: "#fd0088",
    color: "#fff",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "10px",
    padding: "20px 20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
};

const quoteButtonStyle = {
    backgroundColor: "#fff",
    borderColor: "#fd0088",
    color: "#fd0088",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "10px",
    padding: "20px 20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
};

const plusIconContainerStyle = {
    backgroundColor: "#fd0088",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const plusIconStyle = {
    color: "#fff",
    fontSize: "clamp(12px,2vw,17px)",
};

const cartIconContainerStyle = {
    backgroundColor: "#fd0088",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

const cartIconStyle = {
    color: "#fff",
    fontSize: "clamp(16px,2vw,20px)",
}

const contactSectionStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    fontSize: "16px",
    color: "#4A4A4A",
    gap: "8px",
    marginTop: "10px",
};

const contactItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
};

const phoneIconStyle = {
    width: "30px",
    height: "30px",
    backgroundColor: "#4CAF50",
    borderRadius: "50%",
    padding: "5px",
    textAlign: "center",
    color: "#fff",
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "rotate(90deg)"
};

const handIconStyle = {
    width: "20px",  // Adjust based on your design
    height: "20px",
    marginRight: "8px",
};

const listContainerStyle = {
    fontSize: "16px",
    color: "#000",
    lineHeight: "1.8",
};

const linkStyle = {
    fontSize: '16px',
    color: '#ff0080',
    cursor: 'pointer',
    textDecoration: 'none',
};

const detailStyle = {
    fontSize: "clamp(12px,2vw,17px)"
}

const { Title, Text } = Typography;
const { getList } = ApiServeice();


export default function ProductPage() {
    const [isVideo, setisVideo] = useState(false)
    const [mainImage, setMainImage] = useState(null);
    const [productData, setProductData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [pinProducts, setPinProducts] = useState([]);
    const [isLoadingPin, setIsLoadingPin] = useState(true);

    const { setCart } = useContext(MainStore)
    const navigate = useNavigate()

    const [messageApi, contextHolder] = message.useMessage()

    const params = useParams()

    const { getById } = ApiServeice()

    useEffect(() => {
        getProductData()
    }, [])

    function getProductData() {

        if (params.product_id)
            getById(products, params.product_id, { category_id: params.category_id, tag: params.tag_id }).then((response) => {
                setProductData(response.product)

                if (response?.product?.videos?.length > 0) {
                    setMainImage(response.product.videos[0])
                    setisVideo(true)
                } else {
                    setMainImage(response.product.images[0])
                    setisVideo(false)
                }


                setTimeout(() => {
                    setIsLoading(false)
                }, 500);
            }).catch((err) => {
                console.log('err :>> ', err);
            })
        else {
            setProductData(null)
            setIsLoading(false)
        }
    }

    function addProductTocart(isQuotation = false) {
        const cart_local = JSON.parse(localStorage.getItem("cart")) ?? []
        let new_cart = [...cart_local]

        if (new_cart.length >= 5) {
            messageApi.error("จำนวนสินค้าในตะกร้าต้องไม่เกิน 5 ชิ้น / 1 ใบเสนอราคา.");
        }
        else {

            if (cart_local) {
                const is_duplicate = cart_local.find((cart) => cart.id === productData.id)

                if (!is_duplicate) {
                    new_cart.push({ ...productData, product_detail: "", product_qty: 0, product_logo_count: "", product_logo: "", type: 1 })
                    messageApi.open({
                        type: 'success',
                        content: `เพิ่มสินค้า '${productData.name}' ใส่ตะกร้าเรียบร้อยแล้ว.`,
                        duration: 3,
                    })
                } else {
                    if (!isQuotation)
                        messageApi.open({
                            type: 'error',
                            content: `มีสินค้า '${productData.name}' ในตะกร้าแล้ว.`,
                            duration: 3,
                        })
                }

            }
            localStorage.setItem("cart", JSON.stringify(new_cart))
            setCart(new_cart.length)

            if (isQuotation) navigate("/quotation")
        }
    }

    function getPinProducts() {
        setIsLoadingPin(true)
        getList(pin_products).then((response) => {
            setPinProducts(response.data)
            setTimeout(() => {
                setIsLoadingPin(false)
            }, 500);
        }).catch((err) => {
            setPinProducts([])
        })
    }

    useEffect(() => {
        getPinProducts();
    }, []);

    return (
        isLoading ? <Loading description={"กำลังโหลดข้อมูลสินค้า"} /> : <div>
            <BackButton />
            {contextHolder}
            <div style={pageContainerStyle}>
                <div className="grid-container-product-description-images">
                    <div className="grid-container-product-description-main-image-wrapper">
                        <div className="grid-container-product-description-main-image-container">
                            {isVideo && mainImage ? <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                controls
                                alt={productData.name}
                                className="grid-container-product-description-main-image"
                            >
                                <source src={mainImage} type="video/mp4" />
                                <source src={mainImage} type="video/ogg" />
                                Your browser does not support the video tag.
                            </video> : mainImage && <img
                                src={mainImage}
                                alt={productData.name}
                                className="grid-container-product-description-main-image"
                            />}
                        </div>
                    </div>

                    {/* Thumbnail Images (Right) */}

                    <div className="grid-container-product-description-thumbnail-wrapper">
                        <div className="grid-container-product-description-thumbnail-column">
                            {productData?.videos && productData?.videos.length > 0 && productData?.videos.map((video, index) => (
                                <video
                                    key={index}
                                    alt={`Thumbnail ${index + 1}`}
                                    className="grid-container-product-description-thumbnail"
                                    onClick={() => {
                                        setisVideo(true)
                                        setMainImage(video)
                                    }}
                                >
                                    <source src={video} type="video/mp4" />
                                    <source src={video} type="video/ogg" />
                                    Your browser does not support the video tag.
                                </video>
                            ))}
                            {productData?.images.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={`Thumbnail ${index + 1}`}
                                    className="grid-container-product-description-thumbnail"
                                    onClick={() => {
                                        setisVideo(false)
                                        setMainImage(img)
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* Product Info */}
                <div style={productInfoStyle}>
                    <Title level={4} style={titleStyle}>
                        <strong>{productData.name}</strong> - {productData.detail}
                    </Title>
                    <Text style={productCodeStyle}>รหัสสินค้า: {productData.code}</Text>

                    {/* Action Buttons */}
                    <Space className="button-container-product-description">
                        <div className="cart-button-product-description" type="default" onClick={() => addProductTocart(false)}  >
                            <span style={cartIconContainerStyle}>
                                < ShoppingCartOutlined style={cartIconStyle} />
                            </span>
                            เพิ่มใส่ตระกร้า
                        </div>
                        <div className="quote-button-product-description" type="default" onClick={() => addProductTocart(true)} >
                            <span style={plusIconContainerStyle}>
                                <PlusOutlined style={plusIconStyle} />
                            </span>
                            ขอใบเสนอราคา
                        </div>
                    </Space>

                    {/* Contact Section */}

                    <Divider style={{ marginBottom: 0 }} />
                    <div style={contactSectionStyle}>
                        {/* Phone Number */}
                        <div style={contactItemStyle}>
                            <PhoneOutlined style={phoneIconStyle} />
                            <span style={detailStyle}>สอบถามราคา 02-891-3300 หรือ 081-845-2288, 081-810-1818</span>
                        </div>

                        {/* Quotation Request */}
                        <div style={contactItemStyle}>
                            <img src={UpFinger} alt="Up Finger Icon" style={handIconStyle} />
                            <span style={{ fontSize: "clamp(12px,2vw,17px)" }}>ขอใบเสนอราคา คลิกด้านบน</span>
                        </div>
                    </div>

                    {/* Line Button */}
                    <div style={contactSectionStyle}>
                        <LineButton style={detailStyle} />
                    </div>
                    <Divider style={{ marginBottom: 0 }} />
                    <div style={titleStyle}>รายละเอียดสินค้า</div>
                    <div style={detailStyle}>รับผลิตและออกแบบ โดยมืออาชีพ <br />ประสบการณ์กว่า 20 ปี เราเป็น บริษัทพรีเมี่ยม ที่ได้รับการยอมรับจากบริษัทชั้นนำทั่วประเทศไทย</div>

                    <div style={titleStyle}>ข้อมูลเพิ่มเติม</div>
                    <div style={listContainerStyle}>

                        <div style={detailStyle}>
                            1. ราคาขึ้นอยู่กับ แบบสกรีนโลโก้ อุปกรณ์ตกแต่งต่าง ๆ จำนวนที่สั่งผลิต
                        </div>
                        <div style={detailStyle}>
                            2. ระยะเวลาการผลิต 15 – 45 วันหลังจากสรุปแบบครั้งสุดท้าย หรือ สรุปตัวอย่าง
                        </div>
                        <div style={detailStyle}>
                            3. ตัวอย่างใช้เวลา 7 – 10 วัน ขึ้นอยู่กับความยากง่าย (ในกรณีที่สินค้านั้นสามารถทำตัวอย่างได้)
                        </div>
                        <div style={detailStyle}>
                            4. จัดส่งฟรีในเขต กรุงเทพฯ ต่างจังหวัดคิดค่าขนส่งตามจริงจากขนส่งที่ใช้บริการ
                        </div>

                    </div>
                    <div style={{ marginTop: '10px' }}>
                        <div style={detailStyle} > <span style={{ color: "#fd0088", fontWeight: "bold" }}>การขอราคาจากแบบฟอร์ม:</span> <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => addProductTocart(true)}>คลิกที่นี่เพื่อขอราคาโดยใช้แบบฟอร์ม</span></div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <div style={detailStyle}><span style={{ fontWeight: "Bold" }}>วิธีชำระเงิน:</span> เมื่อสั่งผลิต คุณลูกค้าชำระเงินค่ามัดจำ 50% ของออเดอร์ และชำระเงินส่วนที่เหลือ ณ วันจัดส่งสินค้า ขนส่งไปต่างจังหวัด คุณลูกค้าชำระเงินส่วนที่เหลือและค่าขนส่งก่อนนำส่งสินค้า</div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <div style={detailStyle}>สามารถสอบถามรายละเอียดเพิ่มเติมจากฝ่ายขาย ได้ที่ <span style={{ color: "#fd0088", fontWeight: "Bold" }}>02-891-3300 </span>หรือ</div>

                        <div style={{ color: "#fd0088", fontSize: "clamp(12px,2vw,17px)", fontWeight: "bold" }}>คุณเนย</div>
                        <div style={detailStyle}>โทรศัพท์ 02-891-3300 ต่อ 122, มือถือ 081-845-2288 <br />อีเมลล์ 2288@bangkokgift.net</div>

                        <div style={{ color: "#fd0088", fontSize: "clamp(12px,2vw,17px)", fontWeight: "bold" }}>คุณปุ๊ก</div>
                        <div style={detailStyle}>โทรศัพท์ 02-891-3300 ต่อ 129, มือถือ 081-810-1818<br />อีเมลล์ puk@bangkokgift.net</div>

                        <div style={{ color: "#fd0088", fontSize: "clamp(12px,2vw,17px)", fontWeight: "bold" }}>คุณนุ๊ก</div>
                        <div style={detailStyle}>โทรศัพท์ 02-891-3300 ต่อ 139, มือถือ 080-070-8000<br />อีเมล nuuk@bangkokgift.net หรือ nuukonn@gmail.com <br />หรือติดต่อสอบถามผ่านไลน์ที่ด้านล่าง </div>
                    </div>
                    <div className="line-section-product-description">
                        <div style={{ color: "#44ad44", fontWeight: "bold", fontSize: "18px", whiteSpace: "nowrap", margin: 0, lineHeight: "1" }}>
                            ติดต่อสอบถามเพิ่มเติมที่
                        </div>
                        <div style={{ flexShrink: 0 }}>
                            <LineButton />
                        </div>
                    </div>
                </div>
            </div>
            <div className='recommended-titleContainer'>
                <h1 style={{ fontSize: 34, margin: 0 }}>สินค้าแนะนำ</h1>
                <a href="#" style={linkStyle} onClick={() => navigate("/products")}>
                    ดูทั้งหมด
                </a>
            </div>
            {isLoadingPin ? (
                <Loading description={'กำลังโหลด'} />
            ) : (
                <div className='home-pinContainer'>
                    {pinProducts?.map((product, i) => (
                        <ProductCard
                            key={i}
                            name={product.name}
                            description={product.detail}
                            image={product.images[0]}
                            navigate_to={`/products/${product.category_id}/${product.tag_id}/${product.id}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}